import { render, staticRenderFns } from "./AuxiliaryAccountingBalance.vue?vue&type=template&id=58ff34ea&scoped=true"
import script from "./AuxiliaryAccountingBalance.vue?vue&type=script&lang=js"
export * from "./AuxiliaryAccountingBalance.vue?vue&type=script&lang=js"
import style0 from "./AuxiliaryAccountingBalance.vue?vue&type=style&index=0&id=58ff34ea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ff34ea",
  null
  
)

export default component.exports